<div class="station-status" [ngClass]="{'dark-mode': darkMode===true}">
  @if (stationStatus) {
    <div class="left">
      <div class="logo" [ngStyle]="{ 'background-image': 'url('+serverRoot +'/app-client/resource/by-usage/'+tenant+'/display-logo)' }"></div>
      <div class="station-name">
        <div class="label">{{gateLabel}}</div>
        <div class="value">{{stationStatus.stationIdentifier}}</div>
      </div>
    </div>
    <div class="right">
      @if (isLocked()) {
        <div class="disablement-hint">
          <sc-icon iconClass="fa-times fa-3x"></sc-icon>
          <span class="hint">
            <div class="title">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.station-status.locked.hint"></sc-dictionary-label>
            </div>
          </span>
        </div>
      }
      @if (isLocked()) {
        <div class="disablement-hint">
          <sc-icon iconClass="fa-times fa-3x"></sc-icon>
          <span class="hint">
            <div class="title">
              <sc-dictionary-label dictionaryKey="tmc-yard.widgets.station-status.locked.hint"></sc-dictionary-label>
            </div>
          </span>
        </div>
      }
      @if (hasStationDisablement()) {
        <div class="disablement-hint">
          <sc-icon iconClass="fa-exclamation-triangle fa-3x"></sc-icon>
          <span class="hint">
            {{stationStatus.disablementNote}}
          </span>
        </div>
      }
      @if (!hasStationDisablement() && !isLocked()) {
        <div class="transport-data">
          @for (attribute of visibleAttributes; track attribute; let i = $index) {
            @if (getLabelByAttribute(attribute)!='') {
              <div class="value" [ngClass]="attribute">
                <span class="label">
                  {{getLabelByAttribute(attribute)}}
                </span>
                <span class="content" [ngClass]="getClassForAttribute(attribute)">
                  {{getValueByAttribute(attribute)}}
                </span>
              </div>
            }
          }
        </div>
      }
      @if (cameraUrl != null) {
        <div class="camera-view">
          <img [src]="cameraUrl" width="100%"/>
        </div>
      }
      @if (cameraUrl != null) {
        <div class="camera-view">
          <img [src]="cameraUrl" height="100%"/>
        </div>
      }
    </div>
  }
</div>
